<template>
    <modal-base :title="title" :is-active.sync="isActive" @change="choice(true)">
        <div>{{ text }}</div>
        <div class="right-align mt-3">
            <button class="btn btn-default" @click="choice(true)">OK</button>
        </div>
    </modal-base>
</template>

<script>

import ModalBase from "./Base";

export default {

    name: 'wm-modal-confirm',

    props: ['title', 'text'],

    components: { ModalBase },

    data() {
        return {
            isActive: true,
        }
    },

    methods: {
        choice(value) {
            this.$emit('change', value);
            this.isActive = false;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/Modal/Alert.vue